import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from 'src/app/Core/interceptors/http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuctionInterestApiService {
  private markInterestedUrl = `${environment.url}/buyer/auction-calendar/markInterested`;
  private removeInterestedUrl = `${environment.url}/buyer/auction-calendar/removeInterested`;

  constructor(private http: HttpService) {}

  /**
   * Mark an auction as interested
   * @param auctionId - The auction event ID
   * @returns Observable with API response
   */
  markInterested(auctionId: number): Observable<any> {
    const body = {
      auction_event_id: auctionId.toString()
    };

    return this.http.postWithFormData(this.markInterestedUrl, body).pipe(
      catchError((error) => {
        console.error('Error marking auction as interested:', error);
        const errorMessage = this.getErrorMessage(error);
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  /**
   * Remove an auction from interested list
   * @param auctionId - The auction event ID
   * @returns Observable with API response
   */
  removeInterested(auctionId: number): Observable<any> {
    const body = {
      auction_event_id: auctionId.toString()
    };

    return this.http.postWithFormData(this.removeInterestedUrl, body).pipe(
      catchError((error) => {
        console.error('Error removing auction from interested:', error);
        const errorMessage = this.getErrorMessage(error);
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  /**
   * Get user-friendly error message from error response
   */
  private getErrorMessage(error: any): string {
    // Network error
    if (error.status === 0) {
      return 'Unable to connect to the server. Please check your internet connection.';
    }

    // Unauthorized
    if (error.status === 401) {
      return 'Please log in to save auctions to your interested list.';
    }

    // Forbidden
    if (error.status === 403) {
      return 'You do not have permission to perform this action.';
    }

    // Not found
    if (error.status === 404) {
      return 'Auction not found.';
    }

    // Server error
    if (error.status === 500) {
      return 'Server error occurred. Please try again later.';
    }

    // Use API error message if available
    if (error.error && error.error.message) {
      return error.error.message;
    }

    // Generic error
    return 'Failed to update interest. Please try again.';
  }
}
